import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCalculationFields } from "@ploy-lib/calculation";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { Grid, Typography } from "@material-ui/core";
import LightbulbIcon from "@material-ui/icons/EmojiObjects";
import { useTenantImage } from "@ploy-ui/tenants";
import { ImageFit } from "@ploy-ui/core";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { useFormikValueOnChange } from "@ploy-ui/form-fields/es/hooks";
export const IncreaseEquityCTA = (props) => {
    const fields = [
        {
            namespace: "Calculator",
            name: "ObjectPrice"
        },
        {
            namespace: "Calculator",
            name: "Equity"
        },
        {
            namespace: "Calculator",
            name: "EquityPercent"
        },
        {
            namespace: "Calculator",
            name: "MiddleInterestRate"
        },
        {
            namespace: "Calculator",
            name: "BestInterestRate"
        }
    ];
    const calculationFields = useCalculationFields(...fields);
    const objectPrice = Number(calculationFields[0]?.value ?? 0);
    const equity = Number(calculationFields[1]?.value ?? 0);
    const EquityPercent = Number(calculationFields[2]?.value ?? 0);
    const middleInterestRate = Number(calculationFields[3]?.value ?? 0) / 100;
    const bestInterestRate = Number(calculationFields[4]?.value ?? 0) / 100;
    const onChange = useFormikValueOnChange(props);
    const nextInterestRate = EquityPercent >= 20 ? bestInterestRate : middleInterestRate;
    var missingEquity = 0;
    if (EquityPercent < 20) {
        missingEquity = objectPrice * 0.2 - equity;
    }
    else if (EquityPercent >= 20 && EquityPercent < 35) {
        missingEquity = objectPrice * 0.35 - equity;
    }
    const lightbulbIcon = useTenantImage("LightbulbIcon");
    return (_jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", spacing: 1, children: [_jsx(Grid, { item: true, xs: "auto", children: lightbulbIcon ? (_jsx(ImageFit, { src: lightbulbIcon, alt: "lightbulb icon" })) : (_jsx(LightbulbIcon, {})) }), _jsx(Grid, { item: true, children: EquityPercent < 35 ? (_jsx(Typography, { variant: "body2", style: { cursor: "pointer" }, onClick: () => {
                        onChange(equity + missingEquity);
                    }, children: _jsx(FormattedMessage, { id: "template-form.increase-equity-cta.notBestInterestRate", description: "Label for available total", defaultMessage: "\u00D8k egenkapital med {equity} for \u00E5 f\u00E5 {nextInterestRate} i rente.", values: {
                            equity: (_jsx("strong", { children: _jsx(FormattedNumber, { value: missingEquity, format: "currency" }) })),
                            nextInterestRate: (_jsx("strong", { children: _jsx(FormattedNumber, { value: nextInterestRate, format: "percent" }) }))
                        } }) })) : (_jsx(Typography, { variant: "body2", children: _jsx(FormattedMessage, { id: "template-form.increase-equity-cta.bestInterestRate", defaultMessage: "Du har n\u00E5 v\u00E5r beste nominelle rente!." }) })) })] }));
};
export const EditorIncreaseEquityCTA = identityRecordOfFieldEditorOptions({
    IncreaseEquityCTA: {
        editableOptions: {
            placeholder: true
        }
    }
});
//# sourceMappingURL=IncreaseEquityCTA.js.map